/* eslint-disable no-unused-vars */
/** @jsx jsx */
import { jsx } from '@emotion/core'
import React, {
  useEffect,
  useState,
  useContext,
  useMemo,
  useCallback,
} from 'react'
import {
  Grid,
  defaultVirtualizedCellRender,
  virtualizedGridRenderer,
} from '@integec/grid-tools'
import {
  Button,
  DatePicker,
  Divider,
  Icon,
  Popconfirm,
  Radio,
  Select,
  message,
} from 'antd'
import {
  getWind2ContribCondtition,
  wind2EventDelete,
  wind2EventDeleteTurbine,
  // wind2PlantWithSubGroup,
  wind2PowerData,
  getWind2CauseCode,
  wind2SubgroupFormation,
  getWind2AvaliableStatus,
  wind2Level2Validation,
  wind2PlantSelection,
  wind2AllSubgroup,
} from 'api/pgads'
import {
  DataContext,
  ErrorContext,
  JcTmpErrorContext,
  SpinContext,
} from 'context'
import { getApiTargetInfo, getUnits } from 'core'
import {
  Content,
  CriteriaRow,
  Filler,
  FullHeightSizer,
  Label,
  Title,
} from 'core/screen-util'

import { connect } from 'react-redux'
import {
  Wind2NercEventHeaders,
  Wind2PerformanceHeaders,
  Wind2StoragePerformanceIoHeaders,
  Wind2TurbineEventHeaders,
} from './Headers'
import { rowHeaderRender, hasAccesPermits } from 'core/utils'
import Wind2PerformanceDialog from './Wind2PerformanceDialog'
import Wind2EventDialog, { saveDateformat } from './Wind2EventDialog'
import Wind2StoragePerformanceDialog from './Wind2StoragePerformanceDialog'
import PiaTableInfoAntd from './Wind2ColorTableInfoAntd'
// import PieCircleGraph from './Wind2PieCircleGraph'
import DailyGraph from './DailyGraph'

import Wind2TurbineEventDialog from './Wind2TurbineEventDialog'
import R from 'ramda'
import { isErrorContains } from 'core/component/JcTmpErrorDialog'
// import moment from 'moment'
import { getTimeZone, getValidPlantList } from './wind2utils'
import moment from 'moment'
import { getwind2EventTypes } from './wind2api'
import {
  WIND_ADMIN_POWER_DATA_20,
  HIDE_WIND2_TURBINE_PERFORMANCE,
} from '../core/EventActions'
import { getPermitActions } from '../core/selectors'

const Wind2PowerData = ({ targetInfo, actionPermits }) => {
  const [plantSelectionData, setPlantSelectionData] = useState([])
  const {
    selectedWind2Plant,
    setSelectedWind2Plant: setPlantSelected,
  } = useContext(DataContext)
  const plantSelected = Array.isArray(selectedWind2Plant)
    ? selectedWind2Plant[0]
    : selectedWind2Plant
  const [plantList, setPlantList] = useState([])
  const [subGroupList, setSubGroupList] = useState([])
  const [performanceData, setPerformanceData] = useState([])
  const [eventData, setEventData] = useState([])
  const [colorGrid, setColorGrid] = useState([])
  const [pieCircleGraph, setPieCircleGraph] = useState([])
  const [dailyData, setDailyData] = useState([])
  const [barGraphData, setBarGraphData] = useState([])
  const [limit, setLimit] = useState(0)
  const [turbineLimit, setTurbineLimit] = useState(0)
  const [turbineEventData, setturbineEventData] = useState([])
  const [turbineBarGraph, setTurbineBarGraph] = useState([])
  // eslint-disable-next-line no-unused-vars
  const [level2ValidationErrors, setLevel2ValidationErrors] = useState([])
  const [isLever2Validated, setIslever2Validated] = useState(true)
  const [storagePerformance, setStoragePerformance] = useState([])

  const [performanceRowSelected, setPerformanceRowSelected] = useState([])
  const [eventSelected, setEventSelected] = useState([])
  const [turbineSelected, setTurbineSelected] = useState([])
  const [
    storagePerformanceRowSelected,
    setStoragePerformanceRowSelected,
  ] = useState([])

  const [selectedDate, setSelectedDate] = useState(moment().endOf('month'))
  const { setSpinning } = useContext(SpinContext)
  const { setError } = useContext(ErrorContext)
  const { setTmpError } = useContext(JcTmpErrorContext)

  const [showPerformanceDialog, setPerformanceDialog] = useState({})
  const [showEventDialog, setEventDialog] = useState({})
  const [showTurbineEventDialog, setTurbineEventDialog] = useState({})
  const [showStoragePerformanceDialog, setStoragePerformanceDialog] = useState(
    {}
  )

  const [contribConditionList, setContribConditionList] = useState([])
  const [causecodeList, setCausecodeList] = useState([])
  const [turbineIdMap, setTurbineIdMap] = useState([])
  const [avaliablitilityStatusList, setAvalibilityStatusList] = useState([])

  const [isRetrived, setIsRetrieved] = useState(false)
  const [isNercEvents, setIsNercEvent] = useState(true)
  const [selectedPerformanceType, setSelectedPerformacnceType] = useState('P') // p  = per  s=storage perf
  const [eventTypes, setEventTypes] = useState([])

  const hasWindPowerDataWritePermission = useMemo(
    _ =>
      hasAccesPermits({
        actionPermits,
        eventActions: [WIND_ADMIN_POWER_DATA_20],
        matchAny: true,
      }),
    [actionPermits]
  )

  useEffect(
    _ => {
      getWind2AvaliableStatus(targetInfo).fork(_ => _, setAvalibilityStatusList)
      getwind2EventTypes(targetInfo).fork(_ => _, setEventTypes)

      getWind2ContribCondtition(targetInfo).fork(
        _ => _,
        setContribConditionList
      )
      wind2SubgroupFormation(targetInfo).fork(
        _ => _,
        data => {
          const byPlantId = R.compose(R.groupBy(d => d.plantId))(data)
          setTurbineIdMap(byPlantId)
        }
      )

      getWind2CauseCode(targetInfo).fork(
        _ => _,
        data => {
          const matchToSelct = data.map(
            ({ system, subsystem, causecode, description }) => ({
              system,
              component: subsystem,
              causeCode: causecode,
              description,
              unitCode: 'WI',
              unitType: 'WI',
              isOMC: false,
            })
          )
          setCausecodeList(matchToSelct)
        }
      )

      wind2AllSubgroup(targetInfo).fork(setError, setSubGroupList)
    },
    [setError, targetInfo]
  )

  useEffect(
    _ => {
      // make sort plantName
      // wind2PlantWithSubGroup(targetInfo).fork(setError, data => {
      //   const sd = R.sortBy(R.prop('plantName'), data)
      //   setPlantSelectionData(sd)
      //   if (!plantSelected && sd[0] && sd[0].plantId)
      //     setPlantSelected(sd[0].plantId)
      // })
      wind2PlantSelection(targetInfo)({
        year: selectedDate.format('YYYY'),
        month: selectedDate.format('MM'),
      }).fork(setError, data => {
        setPlantList(data)
      })
    },
    [targetInfo, selectedDate, setError]
  )

  useEffect(() => {
    const stoList = getValidPlantList(plantList, subGroupList, [])
    setPlantSelectionData(stoList)
    const isValidSelection = stoList.some(p => p.plantId === plantSelected)
    if (!isValidSelection && stoList[0] && stoList[0].plantId) {
      if (plantSelected !== stoList[0].plantId) {
        setPlantSelected([stoList[0].plantId])
      }
    }
  }, [plantList, plantSelected, setPlantSelected, subGroupList])

  const avalibilityStatusIdMap = useMemo(
    _ => {
      return R.compose(
        R.fromPairs,
        R.map(({ avaliabilityStatusCode, avaliabilityStatusName }) => [
          avaliabilityStatusCode,
          avaliabilityStatusName,
        ])
      )(avaliablitilityStatusList)
    },
    [avaliablitilityStatusList]
  )

  const clearData = _ => {
    setIsRetrieved(false)
    setPerformanceData([])
    setEventData([])

    setColorGrid([])
    setPieCircleGraph([])
    setLimit(parseFloat([]))
    setDailyData([])
    setBarGraphData([])
    setTurbineBarGraph([])
    setturbineEventData([])
    setEventSelected([])
    setTurbineLimit(0)
    setLimit(0)
    setLevel2ValidationErrors([])
    setIslever2Validated(true)
    setStoragePerformance([])
  }

  const retrieveData = (_, cdate = selectedDate) => {
    if (!plantSelected) {
      message.info('Please, Select Plant')
      return
    }
    setSpinning(true)
    wind2PowerData(targetInfo)({
      year: cdate.format('YYYY'),
      month: cdate.format('MM'),
      plantid: plantSelected,
    }).fork(setError, data => {
      setSpinning(false)
      setIsRetrieved(true)
      const { level2ValidationErrors } = data
      setLevel2ValidationErrors(level2ValidationErrors)
      // if (
      //   level2ValidationErrors.length <= 0 ||
      //   !isErrorContains(level2ValidationErrors)
      // ) {
      //   message.info('Level 2 Validation completed successfully.')
      // }
      // if (isErrorContains(level2ValidationErrors))
      setTmpError(level2ValidationErrors)
      setEventData(data.eventData)
      setColorGrid(data.colorGridData)
      setPieCircleGraph(data.colorGridData)
      setLimit(parseFloat(data.maxMWOutages))
      setDailyData(data.dailyData)
      setBarGraphData(data.barGraphData)
      setTurbineBarGraph(data.turbineBarGraphData)
      setturbineEventData(data.turbineEvents)
      setTurbineLimit(data.maxTurbineOutages)

      let perfData = data.performanceData

      perfData = R.sortBy((a, b) => {
        if ((a.subgroupName || '') === 'TOTAL') return 100000
        else {
          return R.toLower((a && a.subgroupName) || '').localeCompare(
            R.toLower((b && b.subgroupName) || '')
          )
        }
      }, perfData)
      setPerformanceData(perfData)

      const storagePerformance = R.sortBy((a, b) => {
        if ((a.subgroupName || '') === 'TOTAL') return 100000
        else {
          return R.toLower((a && a.subgroupName) || '').localeCompare(
            R.toLower((b && b.subgroupName) || '')
          )
        }
      }, data.storagePerformance)

      setStoragePerformance(storagePerformance)

      const lever2Validate = perfData.find(d => d.recordid === 'NOT')
      setIslever2Validated(!lever2Validate)
      setLevel2ValidationErrors(data.level2ValidationError)
    })
  }

  useEffect(
    _ => {
      setEventSelected([])
      setTurbineSelected([])
    },
    [isNercEvents]
  )

  // const [unitCodeMap, setUnitCodeMap] = useState({})
  // useEffect(
  //   _ => {
  //     setUnitCodeMap(unitCodeList(units))
  //   },
  //   [units]
  // )

  const deleteNercEvent = _ => {
    setSpinning(true)
    wind2EventDelete(targetInfo)([eventSelected[0]]).fork(
      setError,
      errorList => {
        setSpinning(false)
        setTmpError(errorList)
        if (!isErrorContains(errorList)) {
          message.info('Data saved.')
          retrieveData()
        }
      }
    )
  }

  // const deleteTurbineEvent = _ => {
  //   setSpinning(true)
  //   wind2EventDeleteTurbine(targetInfo)([turbineSelected[0]]).fork(
  //     setError,
  //     errorList => {
  //       setSpinning(false)
  //       setTmpError(errorList)
  //       if (!isErrorContains(errorList)) {
  //         message.info('Data saved.')
  //         retrieveData()
  //       }
  //     }
  //   )
  // }
  const NercHeaders = useCallback(
    width => Wind2NercEventHeaders(width, contribConditionList),
    [contribConditionList]
  )
  const TurbineHeaders = useCallback(
    width => Wind2TurbineEventHeaders(width, contribConditionList),
    [contribConditionList]
  )

  const getplantIdandEntityId = _ => {
    const sel = plantSelectionData.find(f => f.plantId === plantSelected)
    return { entityId: sel.entityId, plantId: sel.plantId }
  }
  const isPlantLocked = useMemo(
    _ => {
      const total = (performanceData || []).find(
        s => s.subgroupName === 'TOTAL'
      ) || { action: 'U' }
      return total.action === 'L' || total.action === 'l'
    },
    [performanceData]
  )
  const onLevel2Validation = _ => {
    // if (level2ValidationErrors.length <= 0) {
    //   message.info('No validation Warning/Errors.')
    //   // setTmpError([{}])
    // } else setTmpError(level2ValidationErrors)
    setSpinning(true)
    wind2Level2Validation(targetInfo)({
      year: selectedDate.format('YYYY'),
      month: selectedDate.format('MM'),
      plantid: plantSelected,
    }).fork(setTmpError, tmpError => {
      setSpinning(false)
      setTmpError(tmpError)
      if (!isErrorContains(tmpError)) {
        message.info('Level 2 Validation completed successfully.')
      }
      if (tmpError.length <= 0) message.info('No validation Warning/Errors.')
    })
  }

  const lowerGridHeight = useCallback(
    height =>
      height - 150 - 230 - 100 - 100 < 150
        ? 150
        : height - 150 - 230 - 100 - 100,
    []
  )

  const showTurbineEventUpdateDialog = _ => {
    setTurbineEventDialog({
      isNew: false,
      visible: true,
      data: {
        ...turbineSelected[0],
        action: 'U',
      },
    })
  }

  const inverterEventDoubleClick = props => {
    return defaultVirtualizedCellRender({
      ...props,
      // onDoubleClick: _ => {
      //   !isPlantLocked && showTurbineEventUpdateDialog()
      // },
    })
  }

  const showNercEventUpdateDialog = _ => {
    setEventDialog({
      isNew: false,
      visible: true,
      data: {
        ...getplantIdandEntityId(),
        ...eventSelected[0],
        action: 'U',
      },
    })
  }

  const nercEventDoubleClick = props => {
    return defaultVirtualizedCellRender({
      ...props,
      onDoubleClick: _ => {
        !isPlantLocked && showNercEventUpdateDialog()
      },
    })
  }

  const showPerformanceUpdateDialog = _ => {
    setPerformanceDialog({
      isNew: false,
      visible: true,
      data: performanceRowSelected[0],
    })
  }

  const showStoragePerformanceUpdateDialog = _ => {
    setStoragePerformanceDialog({
      isNew: false,
      visible: true,
      data: storagePerformanceRowSelected[0],
    })
  }

  const performanceDoubleClick = props => {
    return defaultVirtualizedCellRender({
      ...props,
      onDoubleClick: _ => {
        const isTtoal =
          performanceRowSelected[0] &&
          (performanceRowSelected[0].subgroupName === 'TOTAL' ||
            performanceRowSelected[0].inverterGroupName === 'TOTAL')
        if (!isTtoal && !R.isNil(isTtoal))
          !isPlantLocked && showPerformanceUpdateDialog()
      },
    })
  }

  const storagePerformanceDoubleClick = props => {
    return defaultVirtualizedCellRender({
      ...props,
      onDoubleClick: _ => {
        const isTtoal =
          storagePerformanceRowSelected[0] &&
          (storagePerformanceRowSelected[0].subgroupName === 'TOTAL' ||
            storagePerformanceRowSelected[0].inverterGroupName === 'TOTAL')
        if (!isTtoal && !R.isNil(isTtoal))
          !isPlantLocked && showStoragePerformanceUpdateDialog()
      },
    })
  }

  const getSelectedPlantDetails = useMemo(
    _ => {
      return plantSelectionData.find(f => f.plantId === plantSelected) || {}
    },
    [plantSelected, plantSelectionData]
  )
  const wind2PerformanceHeadersGrid = useCallback(
    width => {
      const columns = Wind2PerformanceHeaders(avalibilityStatusIdMap)
      const finWidth = (width - 30) / columns.length

      return columns.map(m => ({ ...m, width: finWidth }))
    },
    [avalibilityStatusIdMap]
  )

  const wind2StoragePerformanceHeadersGrid = useCallback(
    width => {
      const columns = Wind2StoragePerformanceIoHeaders(avalibilityStatusIdMap)
      const finWidth = (width - 30) / columns.length

      return columns.map(m => ({ ...m, width: finWidth }))
    },
    [avalibilityStatusIdMap]
  )

  const hideWind2TurbinePerformance = useMemo(
    _ =>
      hasAccesPermits({
        actionPermits,
        eventActions: [HIDE_WIND2_TURBINE_PERFORMANCE],
        matchAny: true,
      }),
    [actionPermits]
  )

  return (
    <div>
      <CriteriaRow>
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'max-content auto max-content',
            width: '100%',
          }}
        >
          <div
            style={{
              display: 'grid',
              gridTemplateColumns: '350px 300px auto auto auto',
              gap: '10px',
            }}
          >
            <Title>Wind Data</Title>

            <Select
              value={plantSelected}
              style={{ width: '100%' }}
              onChange={plantId => {
                setPlantSelected([plantId])
                clearData()
              }}
            >
              {R.sortBy(R.prop('plantName'), plantSelectionData).map(
                ({ plantName, plantId }) => (
                  <Select.Option key={plantId} value={plantId}>
                    {plantName}
                  </Select.Option>
                )
              )}
            </Select>
            <DatePicker.MonthPicker
              allowClear={false}
              style={{ width: '100%' }}
              format="MMMM-YYYY"
              value={selectedDate}
              onChange={d => {
                setSelectedDate(d.endOf('month'))
                clearData()
              }}
            />

            <Button.Group style={{ minWidth: '130px', marginLeft: '10px' }}>
              <Button
                style={{ marginLeft: '10px' }}
                type="primary"
                title="Previous Month"
                onClick={() => {
                  clearData()
                  const dt = selectedDate
                    .clone()
                    .subtract(1, 'M')
                    .endOf('month')
                  setSelectedDate(dt)
                  retrieveData({}, dt)
                }}
              >
                <Icon type="left" />
              </Button>

              <Button
                style={{}}
                type="primary"
                title="Next Month"
                onClick={() => {
                  clearData()
                  const dt = selectedDate
                    .clone()
                    .add(1, 'M')
                    .endOf('month')
                  setSelectedDate(dt)
                  retrieveData({}, dt)
                }}
              >
                <Icon type="right" />
              </Button>
            </Button.Group>
            <Button
              type="primary"
              onClick={retrieveData}
              icon="database"
              style={{ width: '100%' }}
            >
              Retrieve
            </Button>
          </div>
          <Filler />
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr' }}>
            {isRetrived && (
              <div style={{ display: 'flex' }}>
                <Label>
                  <b>Plant Status : </b>
                </Label>
                <Icon
                  type={isPlantLocked ? 'lock' : 'unlock'}
                  style={{
                    fontSize: '30px',
                  }}
                  theme="twoTone"
                />
              </div>
            )}
            {!isRetrived && <div />}
            <Button
              style={{
                marginLeft: '10px',
                backgroundColor: isLever2Validated ? '#75e675' : '#F08080',
                color: 'black',
              }}
              onClick={onLevel2Validation}
              disabled={!isRetrived}
            >
              Level 2 Validation
            </Button>
          </div>
        </div>
      </CriteriaRow>
      <FullHeightSizer heightOffset={200} widthOffset={20}>
        {({ height, width }) => (
          <Content style={{ padding: '10px', height, width }}>
            <div
              style={{
                display: 'grid',
                gridTemplateColumns: width - 200 + 'px 200px',
                gap: '10px',
              }}
            >
              <DailyGraph
                turbineLimit={turbineLimit}
                limit={limit}
                date={selectedDate.clone().startOf('month')}
                totalWidth={width - 100 - 200}
                data={isNercEvents ? barGraphData : turbineBarGraph}
                totalHeight={150}
                generationData={dailyData}
                colorGrid={colorGrid}
                pieCircleGraph={pieCircleGraph}
              />
              <div
                style={{
                  display: 'grid',
                  gridTemplateColumns: '100px',
                  gridRowEnd: 'span 1',
                  rowGap: '5px',
                }}
              >
                <PiaTableInfoAntd data={colorGrid} width={150} />
              </div>

              <div
                style={{
                  display: 'grid',
                  gridTemplateColumns: '500px 80px 20px 70px 20px 70px auto',
                  gap: '5px',
                  alignContent: 'space-around',
                }}
              >
                <div>
                  <Radio.Group
                    onChange={e => {
                      setSelectedPerformacnceType(e.target.value)
                    }}
                    value={selectedPerformanceType}
                  >
                    <Radio value="P">Performance</Radio>
                    <Radio value="S" disabled={storagePerformance.length <= 0}>
                      Storage Performance
                    </Radio>
                  </Radio.Group>
                </div>
                <div>Legend :</div>
                <div
                  style={{
                    backgroundColor: '#00ff00',
                    border: '0px solid black',
                    textAlign: 'center',
                    fontWeight: '600',
                    height: '70%',
                    alignSelf: 'center',
                  }}
                />
                <div>Actual </div>
                <div
                  style={{
                    backgroundColor: 'blue',
                    border: '0px solid black',
                    textAlign: 'center',
                    fontWeight: '600',
                    color: '#f0f8ff',
                    height: '70%',
                    alignSelf: 'center',
                  }}
                />
                <div>Expected</div>
                <div />
              </div>
              <div
                style={{
                  gap: '5px',
                  display: 'grid',
                  paddingRight: '40px',
                  alignItems: 'baseline',
                  alignContent: 'baseline',
                  gridColumnEnd: 'span 1',
                  justifyContent: 'end',
                }}
              >
                {selectedPerformanceType === 'P' && (
                  <Button
                    style={{ gridColumnEnd: 'span 2', width: 'fit-content' }}
                    disabled={
                      !(
                        isRetrived &&
                        performanceRowSelected.length > 0 &&
                        !isPlantLocked
                      )
                    }
                    onClick={showPerformanceUpdateDialog}
                    type="primary"
                  >
                    {hasWindPowerDataWritePermission
                      ? 'Update Performance'
                      : 'View Performance'}
                  </Button>
                )}
                {selectedPerformanceType === 'S' && (
                  <Button
                    style={{ gridColumnEnd: 'span 2', width: 'fit-content' }}
                    disabled={
                      !(
                        isRetrived &&
                        storagePerformanceRowSelected.length > 0 &&
                        !isPlantLocked
                      )
                    }
                    onClick={showStoragePerformanceUpdateDialog}
                    type="primary"
                  >
                    {hasWindPowerDataWritePermission
                      ? 'Update Performance'
                      : 'View Performance'}
                  </Button>
                )}
              </div>

              <div style={{ minHeight: '250px', gridColumnEnd: 'span 2' }}>
                {selectedPerformanceType === 'P' && (
                  <Grid
                    sortEnabled
                    data={performanceData}
                    headers={wind2PerformanceHeadersGrid(width)}
                    altBy={u => u.subgroupName}
                    altBgColor="#ebebeb"
                    // onEditInfoChange={info => editRow(info)}
                    // editInfo={editInfo}
                    render={virtualizedGridRenderer({
                      autoFixColByKey: false,
                      rowHeaderRender,
                      height: 230,
                      width: width - 30,
                      cellRender: performanceDoubleClick,
                    })}
                    //   fuzzyFilter={fuzzyFilter}
                    isEditable={false}
                    onSelectionChange={({ selectedRows }) => {
                      if (
                        selectedRows[0] &&
                        selectedRows[0].subgroupName === 'TOTAL'
                      )
                        setPerformanceRowSelected([])
                      else setPerformanceRowSelected(selectedRows)
                    }}
                    selectionMode="single"
                    selectionType="row"
                    initialSortOptions={wind2PerformanceHeadersGrid(width)}
                  />
                )}

                {selectedPerformanceType === 'S' && (
                  <Grid
                    sortEnabled
                    data={storagePerformance}
                    headers={wind2StoragePerformanceHeadersGrid(width)}
                    altBy={u => u.subgroupName}
                    altBgColor="#ebebeb"
                    // onEditInfoChange={info => editRow(info)}
                    // editInfo={editInfo}
                    render={virtualizedGridRenderer({
                      autoFixColByKey: false,
                      rowHeaderRender,
                      height: 230,
                      width: width - 30,
                      cellRender: storagePerformanceDoubleClick,
                    })}
                    //   fuzzyFilter={fuzzyFilter}
                    isEditable={false}
                    onSelectionChange={({ selectedRows }) => {
                      if (
                        selectedRows[0] &&
                        selectedRows[0].subgroupName === 'TOTAL'
                      )
                        setStoragePerformanceRowSelected([])
                      else setStoragePerformanceRowSelected(selectedRows)
                    }}
                    selectionMode="single"
                    selectionType="row"
                    initialSortOptions={wind2StoragePerformanceHeadersGrid(
                      width
                    )}
                  />
                )}
              </div>
              <Divider style={{ gridColumnEnd: 'span 2', margin: '0px' }} />

              <div
                style={{
                  display: 'grid',
                  width: width - 30,
                  gap: '5px',
                  gridTemplateColumns:
                    'max-content auto max-content max-content max-content',
                  gridTemplateRows: 'min-content',
                  marginRight: '40px',
                  // justifyContent: 'end',
                }}
              >
                <Radio.Group
                  onChange={e => {
                    setIsNercEvent(e.target.value === 'N')
                  }}
                  value={isNercEvents ? 'N' : 'T'}
                >
                  <Radio value="N">NERC Events</Radio>
                  {!hideWind2TurbinePerformance && (
                    <Radio value="T">Turbine Events</Radio>
                  )}
                </Radio.Group>
                <Filler />
                {isNercEvents && (
                  <React.Fragment>
                    {hasWindPowerDataWritePermission && (
                      <Button
                        onClick={_ => {
                          setEventDialog({
                            isNew: false,
                            visible: true,
                            data: {
                              ...getplantIdandEntityId(),
                              isNew: true,
                              visible: true,
                              action: 'A',
                              eventtype: 'FO',
                              eventstart: selectedDate
                                .clone()
                                .startOf('month')
                                .format(saveDateformat),
                              eventstartTimeZone: getTimeZone({
                                pzone: getSelectedPlantDetails.timeZone,
                                daylightSavings:
                                  getSelectedPlantDetails.daylightSaving,
                                date: selectedDate.clone().startOf('month'),
                              }),
                            },
                          })
                        }}
                        disabled={!(isRetrived && !isPlantLocked)}
                        type="primary"
                      >
                        Add Event
                      </Button>
                    )}

                    <Button
                      disabled={
                        !(
                          isRetrived &&
                          !isPlantLocked &&
                          eventSelected.length > 0
                        )
                      }
                      onClick={showNercEventUpdateDialog}
                      type="primary"
                    >
                      {hasWindPowerDataWritePermission
                        ? 'Update Event'
                        : 'View Event'}
                    </Button>
                    {hasWindPowerDataWritePermission && (
                      <Popconfirm
                        title="Delete the task ?"
                        description="Are you sure to delete this task?"
                        onConfirm={deleteNercEvent}
                        onCancel={_ => _}
                        okText="Yes"
                        cancelText="No"
                      >
                        <Button
                          disabled={
                            !(
                              isRetrived &&
                              !isPlantLocked &&
                              eventSelected.length > 0
                            )
                          }
                          type="danger"
                        >
                          Delete Event
                        </Button>
                      </Popconfirm>
                    )}
                  </React.Fragment>
                )}
                {/* {!isNercEvents && (
                  <React.Fragment>
                    <Button
                      onClick={_ => {
                        setTurbineEventDialog({
                          isNew: true,
                          visible: true,
                          data: {
                            ...getplantIdandEntityId(),
                            isNew: true,
                            visible: true,
                            action: 'A',
                            eventtype: 'FO',
                            eventstart: selectedDate
                              .clone()
                              .startOf('month')
                              .format(saveDateformat),
                            eventstartTimeZone: getTimeZone({
                              pzone: getSelectedPlantDetails.timeZone,
                              daylightSavings:
                                getSelectedPlantDetails.daylightSaving,
                              date: selectedDate.clone().startOf('month'),
                            }),
                          },
                        })
                      }}
                      disabled={!(isRetrived && !isPlantLocked)}
                      type="primary"
                    >
                      Add Event
                    </Button>

                    <Button
                      disabled={
                        !(
                          isRetrived &&
                          !isPlantLocked &&
                          turbineSelected.length > 0
                        )
                      }
                      onClick={showTurbineEventUpdateDialog}
                      type="primary"
                    >
                      Update Event
                    </Button>
                    <Popconfirm
                      title="Delete the task ?"
                      description="Are you sure to delete this task?"
                      onConfirm={deleteTurbineEvent}
                      onCancel={_ => _}
                      okText="Yes"
                      cancelText="No"
                    >
                      <Button
                        disabled={
                          !(
                            isRetrived &&
                            !isPlantLocked &&
                            turbineSelected.length > 0
                          )
                        }
                        type="danger"
                      >
                        Delete Event
                      </Button>
                    </Popconfirm>
                  </React.Fragment>
                )} */}
              </div>

              <div />
              {isNercEvents && (
                <div style={{ width: width }}>
                  <Grid
                    data={eventData}
                    headers={NercHeaders(width)}
                    // altBy={u => u.entityId}
                    altBgColor="#ebebeb"
                    // onEditInfoChange={info => editRow(info)}
                    // editInfo={editInfo}
                    render={virtualizedGridRenderer({
                      autoFixColByKey: false,
                      rowHeaderRender,
                      height: lowerGridHeight(height),
                      width: width - 30,
                      headerRowHeight: 30,

                      cellRender: nercEventDoubleClick,
                    })}
                    //   fuzzyFilter={fuzzyFilter}
                    isEditable={false}
                    onSelectionChange={({ selectedRows }) => {
                      setEventSelected(selectedRows)
                    }}
                    selectionMode="single"
                    selectionType="row"
                    initialSortOptions={NercHeaders(width)}
                    // sortOptions={NercHeaders(width)}
                  />
                </div>
              )}

              {!isNercEvents && (
                <div style={{ height: 300 - 20 }}>
                  <Grid
                    data={turbineEventData}
                    headers={TurbineHeaders(width - 40)}
                    // altBy={u => u.entityId}
                    altBgColor="#ebebeb"
                    // onEditInfoChange={info => editRow(info)}
                    // editInfo={editInfo}
                    render={virtualizedGridRenderer({
                      headerRowHeight: 30,
                      autoFixColByKey: false,
                      rowHeaderRender,
                      height: lowerGridHeight(height),
                      width: width - 30,
                      cellRender: inverterEventDoubleClick,
                    })}
                    //   fuzzyFilter={fuzzyFilter}
                    isEditable={false}
                    onSelectionChange={({ selectedRows }) => {
                      setTurbineSelected(selectedRows)
                    }}
                    selectionMode="single"
                    selectionType="row"
                    initialSortOptions={[
                      {
                        ident: 'turbineId',
                        display: 'Turbine ID',
                        isKey: true,
                        sortOrder: 'asc',
                      },
                      // {
                      //   ident: 'eventId',
                      //   display: 'EventId',
                      //   isFiltered: true,
                      //   sortOrder: 'asc',
                      // },
                      { ident: 'eventstart', sortOrder: 'asc' },
                      // { ident: 'eventend', sortOrder: 'asc' },
                    ]}
                    // sortOptions={[
                    //   { ident: 'eventstart', sortOrder: 'asc' },
                    //   { ident: 'eventend', sortOrder: 'asc' },
                    // ]}
                    sortEnabled
                  />
                </div>
              )}
            </div>
          </Content>
        )}
      </FullHeightSizer>
      {showPerformanceDialog.visible && (
        <Wind2PerformanceDialog
          {...showPerformanceDialog}
          targetInfo={targetInfo}
          onHide={_ => {
            setPerformanceDialog({})
          }}
          onRetrieve={retrieveData}
          setError={setError}
          avalibilityStatusIdMap={avalibilityStatusIdMap}
          avaliablitilityStatusList={avaliablitilityStatusList}
        />
      )}
      {showEventDialog.visible && (
        <Wind2EventDialog
          {...showEventDialog}
          targetInfo={targetInfo}
          onHide={_ => {
            setEventDialog({})
          }}
          onRetrieve={retrieveData}
          causeCodeList={causecodeList}
          contribConditionList={contribConditionList}
          selectedPlantDetails={getSelectedPlantDetails}
          eventTypes={eventTypes}
        />
      )}
      {showTurbineEventDialog.visible && (
        <Wind2TurbineEventDialog
          {...showTurbineEventDialog}
          targetInfo={targetInfo}
          onHide={_ => {
            setTurbineEventDialog({})
          }}
          onRetrieve={retrieveData}
          causeCodeList={causecodeList}
          setTmpError={setTmpError}
          contribConditionList={contribConditionList}
          turbineList={turbineIdMap[plantSelected] || []}
          selectedPlantDetails={getSelectedPlantDetails}
          eventTypes={eventTypes}
        />
      )}
      {showStoragePerformanceDialog.visible && (
        <Wind2StoragePerformanceDialog
          {...showStoragePerformanceDialog}
          targetInfo={targetInfo}
          onHide={_ => {
            setStoragePerformanceDialog({})
          }}
          onRetrieve={retrieveData}
          setError={setError}
          avalibilityStatusIdMap={avalibilityStatusIdMap}
          avaliablitilityStatusList={avaliablitilityStatusList}
        />
      )}
    </div>
  )
}

const mapStateToProps = state => ({
  targetInfo: getApiTargetInfo(state),
  // eventTypesData: getEventTypes(state),
  units: getUnits(state),
  actionPermits: getPermitActions(state),
})
export default connect(mapStateToProps)(Wind2PowerData)
